<template>
    <section
        :id="slice.primary.anchorName || undefined"
        :data-slice-type="slice.slice_type"
        :data-slice-variation="slice.variation"
        class="slice slice-charts"
    >
        <div class="slice-content">
            <PrismicRichText v-if="slice.primary.title" :field="slice.primary.title" class="slice-title" />

            <div class="slice-body">
                <div v-for="(item, i) in slice.items" :key="i">
                    <div class="chart-title">{{ item.title }}</div>
                    <PrismicImage :image="item.image" class="chart-image" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {ChartsSlice} from '@prismicio-types';
    import PrismicImage from '~/components/PrismicImage.vue';

    defineProps(getSliceComponentProps<ChartsSlice>(['slice', 'index', 'slices', 'context']));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-charts {
        .chart {
            &-title {
                font-size: var(--joy-font-size-primary-400);
                font-weight: var(--joy-font-weight-bold);
                margin-bottom: var(--joy-core-spacing-4);
            }
            &-image {
                width: 100%;
                max-width: 450px;
                margin: 0 auto;
            }
        }
        .slice-body {
            > div {
                margin-bottom: var(--joy-core-spacing-8);
            }
            @include mq.screen_md(min) {
                display: flex;
                justify-content: center;
                gap: var(--joy-core-spacing-8);
                > div {
                    width: 50%;
                    margin-bottom: 0;
                }
            }
        }
    }
</style>
